if($("#infos").data("pag-atual") == 'pagamento'){

  var url_geral = $("#infos").data("url-base");
  
  function parcelamento(total, parcelas) {
    const infosParcelamento = {
      total: total,
      parcelas: parcelas
    };
    $.ajax({
      type: "POST",
      url: url_geral + "acoes/app/pagarme/parcelamento.php",
      data: infosParcelamento,
      async: false,
      cache: false,
      success: function (response) {
        const campoParcela = $('#parcelas');
        let installments = $.parseJSON(response);
        console.log(installments);
        if (installments.length > 0) {
          $("#parcelas").html("");
          $("#parcelas").append('<option value="" hidden>Parcelas</option>');
          for (let item in installments) {
            if (parseInt(installments[item].installment) <= parseInt(parcelas)) {
              let interestFree = installments[item].interestFree;
              if (typeof installments[item].interestFree === 'string' && installments[item].interestFree === 'false') {
                interestFree = false;
              }
              const installmentFree = interestFree ? ' (sem juros)' : ' (R$ '+formataMoeda(installments[item].amount)+')';
              campoParcela.append(
                `<option value="${installments[item].installment}x${installments[item].installment_amount}">${
                  installments[item].installment
                }x de R$ ${formataMoeda(installments[item].installment_amount)}${installmentFree} </option>`,
              );
            }
          }
        }
      },
    });
  }
  
  let parcelas = $('#limite_parcelas').val();
  let total_compra = $('#valorPagto').val();
  parcelamento(total_compra, parcelas);
  
  // Gera um hash com os dados sensíveis do cartão
  function hahsCartao() {
    const expiration_month = $('#validadeMes').val();
    const expiration_year = $('#validadeAno').val();
    const res_year = expiration_year.substr(2);
    const cardNumber = $('#numero_cartao').val();
    const cardName = $('#nome_cartao').val();
    const cardCvv = $('#cvv').val();
    if (cardNumber != '' && cardName != '' && cardCvv != '') {
      const card = {
        card_number: cardNumber,
        card_holder_name: cardName,
        expiration_month: expiration_month,
        res_year: res_year,
        card_expiration_date: expiration_month + res_year,
        card_cvv: cardCvv,
      };
  
      $.ajax({
        type: "POST",
        url: url_geral + "acoes/app/pagarme/pagarme.php",
        data: card,
        async: false,
        cache: false,
        success: function (response) {
          response = $.parseJSON(response);
          console.log(response);
          if(!response.cardtoken.id){
            $('#cartao_token').val('');
            $("#cartao_valido").val('false');
          }else{
            $('#cartao_token').val(response.cardtoken.id);
            $("#cartao_valido").val('true');
          }
        },
      });
  
    }
  }
  
  // Adiciona o campo com o hash
  function exibeHash(hash) {
    $('#cartao_token').val(hash);
  }
  
  // Chama a função que cria o hash
  $('.campos_cartao_token').on('change', function () {
    hahsCartao();
  });
  
  }
  